"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

exports.__esModule = true;
exports.default = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _objectWithoutPropertiesLoose2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutPropertiesLoose"));

var _assertThisInitialized2 = _interopRequireDefault(require("@babel/runtime/helpers/assertThisInitialized"));

var _inheritsLoose2 = _interopRequireDefault(require("@babel/runtime/helpers/inheritsLoose"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var React = _interopRequireWildcard(require("react"));

var _classnames = _interopRequireDefault(require("classnames"));

var _domLib = require("dom-lib");

var _compose = _interopRequireDefault(require("recompose/compose"));

var _utils = require("./utils");

var _BrowserDetection = require("./utils/BrowserDetection");

var Loader =
/*#__PURE__*/
function (_React$Component) {
  (0, _inheritsLoose2.default)(Loader, _React$Component);

  function Loader() {
    var _this;

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _React$Component.call.apply(_React$Component, [this].concat(args)) || this;
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "loader", null);
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "loaderRef", function (ref) {
      _this.loader = ref;
    });
    return _this;
  }

  var _proto = Loader.prototype;

  _proto.componentDidMount = function componentDidMount() {
    var _this$props = this.props,
        center = _this$props.center,
        backdrop = _this$props.backdrop;

    if (center || backdrop) {
      var width = (0, _domLib.getWidth)(this.loader);
      (0, _domLib.addStyle)(this.loader, {
        display: (0, _BrowserDetection.isIE11)() || (0, _BrowserDetection.isEdge)() ? 'block' : 'table',
        width: width + "px"
      });
    }
  };

  _proto.addPrefix = function addPrefix(name) {
    return (0, _utils.prefix)(this.props.classPrefix)(name);
  };

  _proto.render = function render() {
    var _classNames;

    var _this$props2 = this.props,
        classPrefix = _this$props2.classPrefix,
        className = _this$props2.className,
        inverse = _this$props2.inverse,
        backdrop = _this$props2.backdrop,
        speed = _this$props2.speed,
        center = _this$props2.center,
        vertical = _this$props2.vertical,
        content = _this$props2.content,
        props = (0, _objectWithoutPropertiesLoose2.default)(_this$props2, ["classPrefix", "className", "inverse", "backdrop", "speed", "center", "vertical", "content"]);
    var hasContent = !!content;
    var addPrefix = (0, _utils.prefix)(classPrefix);
    var classes = (0, _classnames.default)(addPrefix('wrapper'), addPrefix("speed-" + speed), className, (_classNames = {}, _classNames[addPrefix('backdrop-wrapper')] = backdrop, _classNames[addPrefix('vertical')] = vertical, _classNames[addPrefix('inverse')] = inverse, _classNames[addPrefix('center')] = center, _classNames[addPrefix('has-content')] = hasContent, _classNames));
    return React.createElement("div", (0, _extends2.default)({}, props, {
      className: classes
    }), backdrop && React.createElement("div", {
      className: addPrefix('backdrop')
    }), React.createElement("div", {
      className: classPrefix,
      ref: this.loaderRef
    }, React.createElement("span", {
      className: addPrefix('spin')
    }), hasContent && React.createElement("span", {
      className: addPrefix('content')
    }, content)));
  };

  return Loader;
}(React.Component);

(0, _defineProperty2.default)(Loader, "defaultProps", {
  speed: 'normal'
});
(0, _defineProperty2.default)(Loader, "handledProps", ["backdrop", "center", "className", "classPrefix", "content", "inverse", "speed", "vertical"]);

var _default = (0, _compose.default)((0, _utils.withStyleProps)({
  hasSize: true
}), (0, _utils.defaultProps)({
  classPrefix: 'loader'
}))(Loader);

exports.default = _default;


//////////////////
// WEBPACK FOOTER
// ./node_modules/rsuite/lib/Loader.js
// module id = 1799
// module chunks = 0